import { LinkButton, UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuburbanBuildersProjectsBanner.css';

export const SuburbanBuildersProjectsBanner: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>
        <div className={styles['title']}>
          <UIHeading2>Постройте дом на этом участке</UIHeading2>
        </div>
        <div className={styles['description']}>
          <UIText1>Проекты домов на любой вкус от надёжных строительных компаний</UIText1>
        </div>
        <LinkButton
          href="/country-builders-projects/?utm_medium=card&utm_content=banner"
          size="M"
          theme="fill_secondary"
          target="_blank"
        >
          Выбрать проект
        </LinkButton>
      </div>
    </div>
  );
};
